import { buildJson } from "./payload.helper";

const socialLinksHelper = {
  forCreate: ({ name, icon, link, status }) =>
    buildJson({ name, icon, link, status }),
  forUpdate: (id, { name, icon, link, status }) => ({
    id,
    body: buildJson({ name, icon, link, status }),
  }),
};

export default socialLinksHelper;
